const TOKEN_KEY = 'kpjm.token';

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY);
}
export function setToken(t: string | null) {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
}

export class ApiError extends Error {
  constructor(public status: number, message: string, public body?: unknown) {
    super(message);
  }
}

export async function api<T = unknown>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers);
  if (!(init.body instanceof FormData) && init.body && !headers.has('content-type')) {
    headers.set('content-type', 'application/json');
  }
  const token = getToken();
  if (token) headers.set('authorization', `Bearer ${token}`);
  const res = await fetch(path, { ...init, headers });
  if (res.status === 401) {
    setToken(null);
    if (location.pathname !== '/login') location.assign('/login');
    throw new ApiError(401, 'unauthorized');
  }
  const text = await res.text();
  const body = text ? safeJson(text) : null;
  if (!res.ok) {
    let msg = `request_failed_${res.status}`;
    if (body && typeof body === 'object' && 'error' in body) {
      const e = (body as { error: unknown }).error;
      if (typeof e === 'string' && e) msg = e;
    }
    throw new ApiError(res.status, msg, body);
  }
  return body as T;
}

function safeJson(s: string): unknown {
  try {
    return JSON.parse(s);
  } catch {
    return s;
  }
}
